import { useAppDispatch, useAppSelector } from "../../../../app/redux/hooks";
import { loginAsync } from "../../../../app/slices/loginSlice/loginSlice";
import CustomButton from "../../../components/custom/button";
import LoginIcon from "@mui/icons-material/Login";
import CustomInput from "../../../components/custom/input";
import { useState } from "react";

import { LoginValues } from "./loginTypes";

import VerifyOtp from "./verifyOtp/verifyOtp";
import { loginValidation } from "./loginValidation";

import { showSnackbar } from "../../../../app/slices/common/customSnackBar/customSnackbarSlice";
export const LoginPart = ({ onClose, isModal, isFromAccount }: LoginValues) => {
  const initialState: LoginValues = {
    mobileNumber: "+91 ",
  };
  const dispatch = useAppDispatch();

  const [verifyOtpVisible, setVerifyOtpVisible] = useState<boolean>(false);
  const [isMobileReadOnly, setIsMobileReadOnly] = useState<boolean>(false);

  const [loginData, setLoginData] = useState(initialState);
  const [errors, setErrors] = useState<Partial<LoginValues>>({});
  const loginSelector = useAppSelector((state: any) => state.login.login);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    navigateNow();
    event.preventDefault();
  };
  const navigateNow = () => {
    const errorCheck = loginValidation(loginData);

    if (Object.keys(errorCheck).length === 0) {
      let payload: any = {
        mobile_number: loginData?.mobileNumber?.replace(" ", ""),
      };
      dispatch(loginAsync(payload)).then((response: any) => {
        if (response.payload?.status === 200) {
          setVerifyOtpVisible(true);
          setIsMobileReadOnly(true);
          dispatch(
            showSnackbar({
              message:
                "Please check your mobile device for a one-time password (OTP) to complete your verification.",
              severity: "success",
            })
          );

          setTimeout(() => {
            dispatch(
              showSnackbar({
                message: `Your one-time password (OTP) is ${response.payload?.data?.otp}`,
                severity: "info",
              })
            );
          }, 1000);
        } else {
          dispatch(
            showSnackbar({
              message: "Please try again later.",
              severity: "error",
              autoHide: 3000,
            })
          );
        }
      });
    } else {
      setErrors(errorCheck);
    }
  };

  const inputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    let curErrors: any = { ...errors };
    delete curErrors[name];
    setErrors(curErrors);
    setLoginData({
      ...loginData,
      [name]: value,
    });
  };

  return (
    <form
      onSubmit={handleSubmit}
      className=""
      id="login-form"
      // action="#"
      // method="post"
      acceptCharset="utf-8"
      data-mailchimp="true"
      style={{ margin: "20px" }}
    >
      <div className="tf-field style-1 mb_15">
        <CustomInput
          type="tel"
          label="Mobile Number"
          name="mobileNumber"
          size="small"
          readOnly={isMobileReadOnly}
          onChange={inputChange}
          variant="outlined"
          value={loginData.mobileNumber}
          error={!!errors?.mobileNumber}
          fullWidth
          helperText={errors?.mobileNumber}
        />
      </div>
      <div className="tf-field style-1 mb_30">
        {verifyOtpVisible && (
          <VerifyOtp
            isModal={isModal}
            onClose={onClose}
            mobileNumber={loginData.mobileNumber}
            isFromAccount={isFromAccount}
          />
        )}
      </div>

      <div className="tf-field style-1 mb_30">
        {!verifyOtpVisible && (
          <CustomButton
            size="large"
            fullWidth
            className=" btn-fill animate-hover-btn "
            loader={loginSelector.loader}
            endIcon={<LoginIcon />}
            name="Login"
            onClick={navigateNow}
          />
        )}
      </div>
    </form>
  );
};
